import React, { useContext, useState } from 'react'
import { useParams } from 'react-router';
import { Context } from '../../../config/store';
import { toast } from 'react-toastify';
import AddBtDataModal from './AddBtDataModal';
import Modal from '../../../components/Modal';
import LenderUgroService from '../.././../services/lender';

const BtCaseActions = (props) => {
    const { state } = useContext(Context);

    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };

    return (
        <div className={`row no-gutters no-wrap ${props.className}`} style={{display: 'block'}}>
            {checkHasPermission('add-drf') && [6,9,18,19].includes(props?.leadStatusId) && <EditFile {...props} />}
        </div>
    );
}

const EditFile = ({ row: { file_id, doc_type, ...rest }, row, reloadTable, editBtDrf }) => {
    const { state } = useContext(Context);
    const leadId = useParams().id;
    const [btModalState, setBtModalState] = useState(false)
    const [btConfirmModalState, setBtConfirmModalState] = useState(false)
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('')

    const toggleBtModal = () => {
        setBtModalState(!btModalState);
    };

    const toggleBtConfirmModal = (type) => {
        if(type == 1){
            setStatus('approve');
        }else{
            setStatus('reject');
        }
        setBtConfirmModalState(!btConfirmModalState)
    }

    const changeDrfStatus = (row) => {
        setLoading(true)
        let formData = new FormData();
        formData.append('id', row.id)
        formData.append('status', status)

        LenderUgroService.changeDrfStatus({ formData, leadId, lenderId:row?.cl_lender_id }).then((response) => {
			setLoading(false)
            toast.success(response?.data?.messages?.success?.others[0])
			setBtConfirmModalState(false);
			reloadTable(leadId);
        }).catch((err) => {
			setLoading(false)
            toast.error(err?.response?.data?.messages?.error?.form?.[0] || err?.response?.data?.messages?.error?.others?.[0])
			setBtConfirmModalState(false);
        });
        console.log(row.id);
    }

    return (
        <>
            {row?.drf_status === null && <i class="fa fa-pencil fa-2x mr-2" style={{ color: '#4A4E88', cursor: 'pointer' }} title="Edit" onClick={toggleBtModal}></i>}
            {row?.cl_lender_id == 21 && row?.drf_status === null && <i class="fa fa-check fa-2x text-success mr-2" style={{ cursor: 'pointer' }} title='Approve' onClick={()=>toggleBtConfirmModal(1)}></i>}
            {row?.cl_lender_id == 21 && row?.drf_status === null && <i class="fa fa-close fa-2x text-danger" style={{ cursor: 'pointer' }} title='Reject' onClick={()=>toggleBtConfirmModal(0)}></i>}
            {row?.cl_lender_id == 21 && row?.drf_status === 1 && <span style={{color: 'green', fontWeight: 600}}>APPROVED</span>}
            {row?.cl_lender_id == 21 && row?.drf_status === 0 && <span style={{color: 'red', fontWeight: 600}}>REJECTED</span>}
            {btModalState && (
                <AddBtDataModal
                    userType={state.userType}
                    state={btModalState}
                    toggleModal={toggleBtModal}
                    leadId={row?.cl_lead_id}
                    selectedLender={row?.cl_lender_id}
                    reloadTable={reloadTable}
                    data={row}
                    editBtDrf={editBtDrf}
                />
            )}
            <Modal state={btConfirmModalState} closeModal={()=>setBtConfirmModalState(false)} style={{ width: '450px' }} removeBorderSpace={true} closeOnOverlayClick={false}>
                <div className='card border-0'>
                    {/* <div className="modal-header-container">
                        <div className="modal-title"></div>
                        <div className="closeModalView">
                            <span className="closeModalIcon">x</span>
                        </div>
                    </div> */}
                    <div className='text-center mt-3'>
                        {`Do you want to ${status.toUpperCase()} this Transaction?`}<br />
                    </div>
                    <div className='d-flex justify-content-center align-items-center mt-3 mb-3'>
                        <button
                            type='button'
                            className='btn btn-custom'
                            disabled={loading}
                            style={{'pointerEvents': loading? 'none': 'auto'}}
                            onClick={() => changeDrfStatus(row)}
                        >
                        {loading ? <div className='loader' /> : 'Yes'}
                        </button>
                        <button
                            type='button'
                            className='btn btn-outline-custom ml-2'
                            onClick={()=>setBtConfirmModalState(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default BtCaseActions